/** Fuso operacional TransGrãos: America/Sao_Paulo, UTC-3 fixo (sem horário de verão
 *  desde 2019), espelhando o backend (app/utils/tz.py). Centraliza "hoje"/offset de
 *  dias e a leitura de instantes no fuso local, SEM depender do fuso do navegador.
 *
 *  O bug clássico que isto elimina: derivar "hoje" com `new Date().toISOString()` usa
 *  UTC, então às 21h no Brasil (UTC-3) o UTC já virou o dia seguinte. */
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

/** IANA do fuso operacional (para Intl.DateTimeFormat / toLocale*). */
export const SP_TZ = 'America/Sao_Paulo'
const SP_OFFSET_MIN = -180 // UTC-3

/** Instante deslocado para a "parede" de São Paulo: suas partes UTC passam a ser as de SP. */
function spWall(instant: Date): Date {
  return new Date(instant.getTime() + SP_OFFSET_MIN * 60_000)
}

/** Data de calendário YYYY-MM-DD em São Paulo, com deslocamento opcional em dias. */
export function dayISO(offsetDays = 0): string {
  const w = spWall(new Date())
  w.setUTCDate(w.getUTCDate() + offsetDays)
  return w.toISOString().slice(0, 10)
}

/** "Hoje" em São Paulo (YYYY-MM-DD). Use no lugar de `new Date().toISOString().slice(0,10)`. */
export function todayISO(): string {
  return dayISO(0)
}

/** Instante em ms para ORDENAR valores da API que misturam ISO com hora e data pura
 *  `YYYY-MM-DD`. A data pura vira meia-noite de São Paulo, e não de UTC: assim a
 *  prancha escalada para o dia 15 fica junto das cargas do dia 15, e não antes das
 *  cargas das 00:30 do mesmo dia. `null` para valor vazio ou ilegível. */
export function apiInstantMs(v: string | null | undefined): number | null {
  if (!v) return null
  const s = String(v)
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (m) return Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])) - SP_OFFSET_MIN * 60_000
  const t = new Date(s).getTime()
  return Number.isNaN(t) ? null : t
}

/** dayjs de um ISO fixado no fuso de São Paulo, para exibir um instante SEMPRE em SP
 *  (independente do fuso do navegador). Use com timestamps (ISO com Z/offset). */
export function spDayjs(iso: string): dayjs.Dayjs {
  return dayjs(iso).utcOffset(SP_OFFSET_MIN)
}
